export default __webpack_public_path__ + "static/media/emptyStatePurchases.ea4bb4f6.svg";